/* eslint-disable no-restricted-imports */
import * as React from "react";

import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";
import { useAppMenuButton } from "@1js/acui-button/lib/Next";
import { renderMenuButton_unstable } from "@fluentui/react-components";
import { usePreviewGalleryMenuButtonStyles } from "./useAppPreviewGalleryMenuButtonStyles.styles";

export const AppPreviewGalleryMenuButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppMenuButtonProps>((props, ref) => {
    const state = useAppMenuButton(props, ref);

    usePreviewGalleryMenuButtonStyles(state);

    return renderMenuButton_unstable(state);
  })
);

AppPreviewGalleryMenuButton.displayName = "next/useAppPreviewGalleryMenuButton";

export type AppPreviewGalleryMenuButton =
  typeof AppPreviewGalleryMenuButton.prototype;
